module.exports = __webpack_public_path__ + "static/media/sidebar.15dbcbc9.jpg";